import { ThemeColor } from '@qnpm/q-theme';
import React, { Component } from 'react';
import { StyleSheet, View, TouchableOpacity, Text, Image } from 'react-native';

export default class PassengersPopLayer extends Component<any> {

    changePassenger(item: any, idx: number) {
        // item 当前乘机人相关信息
        // idx 当前产品在productInfoList中的位置
        const data = this.props.marketing || {};
        // let productType = this.props.productType || '';
        this.submitMarketingData(item, idx, data);
    }

    submitMarketingData(item: any, index: number, data: any) {
        const { clearProductInfoList = [], formData = {} } = data || {};
        const { orderRecords } = formData || {};
        const flag = orderRecords.some((v: any) => v.productType === item.productType);

        if (flag) { // 相同产品
            for (let k = 0; k < orderRecords.length; k++) {
                const orderRecordItem = orderRecords[k];
                const temp = orderRecordItem.cardNo === item.cardNo && (orderRecordItem.productType === item.productType);

                if (temp) {
                    // 当前索引的证件号码相同 && 产品相同 去掉勾选
                    formData.orderRecords.splice(k, 1);

                    clearProductInfoList[index].cardNoShow = '';
                    break;
                } else if (orderRecordItem.productType === item.productType) {
                    // 单纯的产品相同，则替换之前选中值
                    formData.orderRecords[k] = item;
                    clearProductInfoList[index].cardNoShow = item.cardNoShow;
                    break;
                }
            }
        } else {
            // 不同产品
            formData.orderRecords.push(item);
            clearProductInfoList[index].cardNoShow = item.cardNoShow;
        }
        this.props.setMarketing(data);
    };

    render() {
        const { data = [], formData = {}, idx, productType = '' } = this.props;
        const { orderRecords = [] } = formData || {};

        if (!data) {
            return null;
        }
        return (
            <View style={styles.psgRow}>
                {
                    data.map((psgItem: any, j: number) => {
                        const { passengerName = '', cardNo = '', productType: itemPdtType } = psgItem || {};
                        const flag = orderRecords.filter((item: any) => item.cardNo === cardNo && item.productType === itemPdtType).length > 0;

                        const active = flag ? styles.active : {};

                        const url = 'https://s.qunarzz.com/flight_order_rn/images/checked.png';

                        // 渲染乘机人
                        return (
                            <TouchableOpacity
                                key={j}
                                style={styles.psgCol}
                                onPress={() => {
                                    this.changePassenger(psgItem, idx);
                                }}
                            >
                                <View style={[styles.psgColInfo, active]}>
                                    {
                                        flag
                                            ? <View style={styles.arrowBox}>
                                                <Image style={styles.arrow} source={{ uri: url }} />
                                            </View>
                                            : null
                                    }
                                    <Text style={styles.psgColText} numberOfLines={6}>{passengerName}</Text>
                                </View>
                            </TouchableOpacity>
                        );
                    })
                }
            </View>
        );
    }
}

const styles = StyleSheet.create({
    // 产品乘机人
    psgRow: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        textAlign: 'center'
        // backgroundColor: 'red'
    },
    psgCol: {
        height: 32,
        flex: 0,
        width: '33.3333%',
        marginBottom: 8
    },
    psgColInfo: {
        marginHorizontal: 4,
        paddingHorizontal: 8,
        backgroundColor: '#fff',
        borderRadius: 4,
        height: 32,
        overflow: 'hidden',
        borderStyle: 'solid',
        borderWidth: 0.5,
        borderColor: '#fff'
    },
    psgColText: {
        textAlign: 'center',
        fontSize: 13,
        lineHeight: 30
    },
    active: {
        overflow: 'hidden',
        borderStyle: 'solid',
        borderWidth: 0.5,
        borderColor: '#00bcd4',
        position: 'relative'
    },
    arrowBox: {
        position: 'absolute',
        bottom: -0.5,
        right: -0.5
    },
    arrow: {
        width: 18,
        height: 18
    },
    idNumber: {
        paddingLeft: 4,
        paddingTop: 4,
        paddingBottom: 8,
        fontSize: 12,
        lineHeight: 17,
        color: ThemeColor.text2
    }
});
